import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

export default class SearchField extends Component {
  static defaultProps = {
      'color': Theme.white,
  }

  componentDidMount(){
    this.searchField.focus();
  }

  /*
   * When the value of the input field changes the
   * handler(key, value) on props is called
   */
  onChange(e) {
    e.preventDefault();
    this.props.handler(this.props.key, e.target.value);
  }

  render() {
    const styles = StyleSheet.create({
      container: {
        position: 'relative',
        width: '100%',
        'caret-color': Theme.primary,
        border: 'none',
        borderStyle: 'none',
        backgroundColor: 'transparent',
        fontFamily: Theme.fontFamily,
        fontSize: 35,
        fontWeight: '700',
        letterSpacing: 1,
        outline: 'none',
        color: this.props.color,
      },
    });

    return (
      <input
        type="text"
        className={css(styles.container)}
        ref={(input) => { this.searchField = input; }}
        value={this.props.value}
        onChange={this.onChange.bind(this)} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchField/index.js